import styled from "styled-components";

export const NewContainer = styled.div`
  display: flex;
  align-items: flex-start;
  min-height: 80vh;
  flex-direction: column;
  gap: 0;
  justify-content: center;
  margin: auto;
  margin-bottom: 1rem;
  width: 80%;
  color: #101e8e;
  img {
    width: 100%;
    object-fit: contain;
    height: 30%;
  }
`;

export const NewsData = styled.section`
  section {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
  }
  display: flex;
  flex-direction: column;
`;
